import React from 'react'
import './application-modal-2024.css'
import { MdCheck, MdClose, MdMoreVert } from 'react-icons/md'
import DropdownWithImage from '../DanitComponents/Dropdown/DropdownWithImage/DropdownWithImage'
import { modalOwnerOptions, modalSchoolOptions } from '../StudentOnboardingFall2023/student-onboarding-fall-2023-info'
import NoteAreaFall2023 from '../StudentOnboardingCardModalFall2023/NoteAreaFall2023/NoteAreaFall2023'
import { convertSchoolNamesToAbbreviations } from '../utilityFunctions'
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023'
import axios from 'axios'
import { getRequestHeaders } from '../api'
import { baseUrl } from '../assets/Animations'
import SimpleAlert from '../DanitComponents/Modals/SimpleAlert'
import WarningPopup from '../DanitComponents/Modals/WarningPopup/WarningPopup'

const ApplicationModal2024 = ({setApplication, setApplications, application, deleteApplication, toggleLoadingScreen, setError, pushItem, userData, createNoteFunc, setSimpleNotification}) => {
    const [openDropdown, setOpenDropdown] = React.useState(false)
    const [simpleAlert, setSimpleAlert] = React.useState(false)
    const [warningPopup, setWarningPopup] = React.useState(false)
    const details = [
        {label: 'Email', value: `${application.key3app}`},
        {label: 'Areas', value: `${application.key22app}`},
        {label: 'Experience', value: `${application.key6app} years`},
        {label: 'Home Town', value: `${application.key5app}`},
        {label: 'Instrument(s)', value: `${application.key13app.map(inst => inst.name).join(', ')}`},
        {label: 'Desired Studio Size', value: `${application.key9app} Students`}
    ]
    const checkMarkList = [
        {label: 'Background Check', value: `${application.key17app}`},
        {label: 'Has Vehicle', value: `${application.key18app}`},
        {label: 'Has Driver\'s License', value: `${application.key19app}`},
        {label: 'Previous In-Home Experience', value: `${application.key7app}`},
    ]
    const dropDownMenuOptions = [
        {
            label: 'Move to Waitlist (no email)',
            onClick: () => moveApplicationWithNoEmail('waitlist')
        },
        {
            label: 'Move to interview (no email)',
            onClick: () => moveApplicationWithNoEmail('interviewing')
        },
        {
            label: 'Move to Onboard (no email)',
            onClick: () => moveApplicationWithNoEmail('onboarding')
        },
        {
            label: 'Delete Application',
            onClick: () => areYouSureYouWantToDelete()
        }
    ]

    const moveApplicationWithNoEmail = (column) => {
        axios.post(`${baseUrl}/process-application/${column}/${application.id}`, {column}, getRequestHeaders())
        .then((res) => {
            pushItem(res.data)
            setApplications(prev => prev.map(app => {
                if (app.id === application.id) {
                    return { ...app, archived: true };
                }
                return app;
            }));
            setApplication(false)
        })
        .catch((err) => setError({message: err.response.data, status: err.response.status}))
    }

    const moveApplicationWithEmail = (column) => {
        axios.post(`${baseUrl}/process-application-with-email/${column}/${application.id}`, {column}, getRequestHeaders())
        .then((res) => {
            if(column === 'deny') {
                setApplications(prev => prev.map(app => {
                    if (app.id === application.id) {
                        return { ...app, archived: true };
                    }
                    return app;
                }));
                setSimpleNotification({
                    title: `${application.key1app} ${application.key2app}'s application has been denied.`, 
                    subtitle: 'An email has been sent to the applicant informing them that we are not going to move forward with them. ', 
                    show: true,
                    style: {
                        backgroundColor: 'bg-red-100',
                        titleColor: 'text-red-800',
                        subtitleColor: 'text-red-800'
                    },
                    approved: false,
                    action: function() {
                        setSimpleNotification(prev => ({...prev, show: false}));
                    }
                })
                setApplication(false)
            } else {
                pushItem(res.data)
                setApplications(prev => prev.map(app => {
                    if (app.id === application.id) {
                        return { ...app, archived: true };
                    }
                    return app;
                }));
                setSimpleNotification({
                    title: `${application.key1app} ${application.key2app} has been moved to ${column}.`, 
                    subtitle: `An email has been sent to the applicant informing them that they’ve been moved to ${column}.`, 
                    show: true,
                    style: {
                        backgroundColor: 'bg-green-100',
                        titleColor: 'text-green-800',
                        subtitleColor: 'text-green-800'
                    },
                    approved: true,
                    action: function() {
                        setSimpleNotification(prev => ({...prev, show: false}));
                    }
                })
                setApplication(false)
            }
        })
        .catch((err) => console.log(err))
    }

    const splitLinksBySpacesAndWrapInAnchorTags = (links) => {
        let splitSpaces = links.split(' ');
        let httpsLinks = splitSpaces.filter(link => link.includes('https://') || link.includes('http://'));
        const anchoredLinks = httpsLinks.map((link, index) => {
                return <div className='application-modal-2024__link-anchors'>Link {index + 1}: <a href={link} target='_blank' rel='noreferrer'>{link}</a></div>;
        });
        return anchoredLinks;
    }

    const interviewButton = () => {
        setWarningPopup({
            type: 'confirm',
            title: 'Interview this applicant?',
            message: 'Applicant will receive an email with instructions to set up an interview, and the card will be moved to “interviewing.”',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, INTERVIEW',
                action: () => moveApplicationWithEmail('interviewing')
            } 
        })
    }

    const waitlistButton = () => {
        setWarningPopup({
            type: 'confirm',
            title: 'Move applicant to waitlist?',
            message: 'Applicant will receive an auto-email letting them know that they’ve been waitlisted.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, WAITLIST',
                action: () => moveApplicationWithEmail('waitlist')
            } 
        })
    }

    const denyButton = () => {
        setWarningPopup({
            type: 'warning',
            title: 'Deny this applicant?',
            message: 'If you deny, applicant will receive an auto-email informing them that we are not going to move forward with them. This cannot be undone.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, DENY',
                action: () => moveApplicationWithEmail('deny')
            } 
        })
    }

    const areYouSureYouWantToDelete = () => {
        setWarningPopup({
            type: 'warning',
            title: 'Are you sure you want to delete this application?',
            message: 'If deleted, this application will be removed from the onboarding page. This cannot be undone. No auto-email will be sent.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, Delete',
                action: () => deleteApplication(application.id)
            } 
        })
    }



    return (
        <div className='student-onboarding-card-modal-fall-2023__wrapper' id='student-onboarding-card-modal-fall-2023__wrapper' onClick={(e) => e.target.id === 'student-onboarding-card-modal-fall-2023__wrapper' && setApplication(false)}>
            {simpleAlert && <SimpleAlert title={simpleAlert.title} message={simpleAlert.message} yesFunction={simpleAlert.yesFunction} noFunction={simpleAlert.noFunction} yesText={simpleAlert.yesText} noText={simpleAlert.noText} />}
            {warningPopup && <WarningPopup warningPopup={warningPopup} />}
            <div className='student-onboarding-card-modal-fall-2023__closing-x__gutter'>
                <div className='student-onboarding-card-modal-fall-2023__closing-x__wrapper'>
                    <MdClose onClick={() => setApplication(false)} color='#334155' size={24}/>
                </div>
            </div>
            <div className='application-modal-2024__main-card'>
            <div className='application-modal-2024'>
                {openDropdown && <ModalDropdownMenuFall2023 menuItems={dropDownMenuOptions} setOpenDropdown={setOpenDropdown}  />}
                <div className='application-modal-2024__header'>
                    <div className='application-modal-2024__top-header'>
                        <div className='application-modal-2024__top-header__group'>
                            <div className='application-modal-2024__top-header__type'>APPLICATION</div>
                            <div className='application-modal-2024__top-header__chip'>Career Page</div>
                        </div>
                        <MdMoreVert color='#94A3B8' size={24} onClick={() => setOpenDropdown(!openDropdown)} />
                    </div>
                    <div className='application-modal-2024__header__applicant-name'>{application.key1app} {application.key2app}</div>
                    <div className='application-modal-2024__header__dropdown-selectors'>
                        <div className='modal-area-fall-2023__selector__admin'>
                            <DropdownWithImage options={modalOwnerOptions} value={'Courtney'}  />
                        </div>
                        <div className='modal-area-fall-2023__selector__admin'>
                            <DropdownWithImage options={modalSchoolOptions} value={convertSchoolNamesToAbbreviations(application.key14app)} />
                        </div>
                    </div>
                </div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>DETAILS</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__detail__wrapper'>
                    {details.map(detail => (
                        <div className='application-modal-2024__detail'>
                            <div className='application-modal-2024__detail__label'>{detail.label}</div>
                            <div className='application-modal-2024__detail__value'>{detail.value}</div>
                        </div>
                    ))}
                    <div className='application-modal-2024__detail'>
                        {checkMarkList.map(check => (
                            <div className='application-modal-2024__detail__check__wrapper'>
                                {check.value === 'true' ? <MdCheck color='#14B8A6' size={24} /> : <MdClose color='red' size={24} />}
                                <div className='application-modal-2024__detail__label'>{check.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>EDUCATION</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key11app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>COVER LETTER</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key10app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>EXPERIENCE</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key12app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>LINKS</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key20app}</div>
                <div className='application-modal-2024__paragraph-answer'>{splitLinksBySpacesAndWrapInAnchorTags(application.key20app)}</div>
                <div className='application-modal-2024__button-wrapper'>
                    {!application.archived && <div className='application-modal-2024__button-deny' onClick={() => denyButton()}>Deny</div>}
                    <div className='application-modal-2024__bottom-btn-area__spacer'></div>
                    <div className='application-modal-2024__button-waitlist' onClick={() => waitlistButton()}>Move to Waitlist</div>
                    <div className='application-modal-2024__button-interview' onClick={() => interviewButton()}>Interview</div>
                </div>
            </div>
            </div>

            <div className='student-onboarding-card-modal-fall-2023__notes-area'>
                <NoteAreaFall2023 
                    modalInfo={{id: application.id, type: 'applicationId', displayName: `${application.key1app} ${application.key2app}`}}  
                    userData={userData} 
                    createNoteFunc={createNoteFunc} 
                    school={convertSchoolNamesToAbbreviations(application.key14app)}
                />
            </div>
        </div>
    )
}
export default ApplicationModal2024